module.exports = __webpack_public_path__ + "media/images/fake/004-82094196ef5e437bc26c244aaf0fa33b.jpg";